import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Crown, Lock, Sparkles, Check, ArrowRight, Gift } from 'lucide-react';

const ProGate = ({ children, feature, description, benefits, preview }) => {
  const { isAuthenticated, getSubscriptionStatus } = useAuth();
  const subscriptionStatus = getSubscriptionStatus();
  const isPro = subscriptionStatus === 'pro' || subscriptionStatus === 'trial';

  if (isPro) {
    return children;
  }

  return (
    <div className="pro-gate-page">
      <div className="pro-gate-card">
        <div className="pro-gate-badge">
          <Crown size={16} />
          <span>Fonctionnalité Pro</span>
        </div>
        
        <div className="pro-gate-emoji">🔒</div>
        
        <h1>{feature}</h1>
        <p className="pro-gate-desc">{description}</p>

        {benefits && benefits.length > 0 && (
          <div className="pro-gate-benefits">
            {benefits.map((benefit, i) => (
              <div key={i} className="benefit-row">
                <div className="benefit-check">
                  <Check size={16} />
                </div>
                <span>{benefit}</span>
              </div>
            ))}
          </div>
        )}

        <a 
          href="https://buy.stripe.com/4gMaEX62y94r2o6cUMdwc00" 
          target="_blank" 
          rel="noopener noreferrer"
          className="pro-gate-cta-btn"
        >
          <Gift size={20} />
          <span>Essayer 7 jours gratuitement</span>
          <ArrowRight size={18} />
        </a>

        <div className="pro-gate-price-info">
          <span className="price-tag">Puis seulement <strong>8,99€/mois</strong></span>
          <span className="cancel-info">Sans engagement • Annule quand tu veux</span>
        </div>

        <div className="pro-gate-trust">
          <Sparkles size={16} />
          <span>Satisfait ou remboursé pendant 30 jours</span>
        </div>
      </div>
    </div>
  );
};

export default ProGate;
